export interface Permission {
  permission: string;
  status: boolean;
}
